export enum LogActionTypes {
  FILTER_ALARM = "@@Log/FILTER_ALARM",
  SELECT_DATE = "@@Log/SELECT_DATE",
  RERENDER = "@@Log/RERENDER",
  RESET_STATE = "@@Log/RESET_STATE",
  SET_FILTER = "@@Log/SET_FILTER"
}
